import { render, staticRenderFns } from "./nameFurigana.vue?vue&type=template&id=75868c6e&"
import script from "./nameFurigana.vue?vue&type=script&lang=js&"
export * from "./nameFurigana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports